// Throttle updates from the `operator` to `fps`
class FPSLocker {
    constructor (operation, fps = 60) {
        this.last = 0;
        this.hz = 1000/fps;
        this.af;
        this.operation = operation;
    }

    schedule () {
        this.clearSchedule();
        this.af = requestAnimationFrame((timing) => {
            this.schedule();
            const diff = timing - this.last;

            if (diff >= this.hz) {
                this.last = timing - (diff % this.hz);
                this.operation(timing);
            }
        });
    }

    clearSchedule () {
        cancelAnimationFrame(this.af);
    }

    destroy () {
        this.clearSchedule();
        this.operation = null;
    }
};

export default FPSLocker;
